import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface SubmitBtnProps {
	type?: 'submit' | 'confirm' | 'destroy' | 'login' | 'register';
}

const SubmitBtn = ({ type = 'submit' }: SubmitBtnProps) => {
	const { t } = useTranslation();

	return (
		<Button
			disableRipple
			fullWidth
			variant="contained"
			size="large"
			type="submit"
			sx={{ borderRadius: type === 'destroy' ? '0px' : '12px' }}
		>
			{t(`form.${type}`)}
		</Button>
	);
};

export default SubmitBtn;
